import request from '@/utils/request'
import { ouchnCustom } from "@/service"

//作者库作者列表
export function ListAuthor(query){
  return request({
    url:ouchnCustom + '/web/oc/author/selectAuthorList',
    method:'get',
    params: query
  })
}
// 作者详情——左侧作者信息
export function AuthorInfo(authorId){
  return request({
    url:ouchnCustom + '/web/oc/author/getAuthorDetails?authorId='+authorId,
    method:'get',
  })
}
// 作者详情——右侧商品列表
export function ListResource(query){
  return request({
    url:ouchnCustom + '/web/oc/author/selectAuthorGoods',
    method:'get',
    params: query
  })
}